import { render, staticRenderFns } from "./teacherUserPro.vue?vue&type=template&id=5770061c&scoped=true"
import script from "./teacherUserPro.vue?vue&type=script&lang=js"
export * from "./teacherUserPro.vue?vue&type=script&lang=js"
import style0 from "./teacherUserPro.vue?vue&type=style&index=0&id=5770061c&prod&lang=scss&scoped=true"
import style1 from "./teacherUserPro.vue?vue&type=style&index=1&id=5770061c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5770061c",
  null
  
)

export default component.exports